import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Source } from '../../interfaces';

@Component({
  selector: 'app-sources-list',
  templateUrl: './sources-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SourcesListComponent {
  @Input() sources: Source[];

  links(link: string): string[] {
    return link.replace(/\s/g, '').split('|');
  }
}
